export const BRAND_NAME = 'Shreenath365online';
// Note: It is the main site url. Ex - krishna365.com, etc.
export const BRAND_DOMAIN = 'shreenath365.online';
// Note: It is the main site url. Ex - krishna365.com, etc.
export const BRAND_DOMAIN_SKIN_URL = 'shreenath365.online';
export const PROVIDER = 'BetFair';
export const PROVIDER_ID = 'BetFair';
export const BACKEND_DOMAIN = 'krna79.com';